import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, ModalController, Events, Navbar } from 'ionic-angular';
import { HttpClient } from '../../../../services/HttpClient';
import { CustomToast } from '../../../../util/CustomToast';
import * as moment from 'moment';
import { AlertController } from 'ionic-angular/components/alert/alert-controller';

@Component({
  selector: 'page-add-publication',
  templateUrl: 'addPublication.html',
  providers : [HttpClient, CustomToast]
})
export class AddPublicationPage {

  modalCtrl : ModalController;
	
  httpClient : HttpClient;

  publication = {
    name : '',
    date : '',
    url : '',
    vol_pag : '',
    authors : '',
    journal : ''
  };

  customToast : CustomToast;
  events : Events;

  @ViewChild(Navbar) navBar : Navbar;

  minDate = moment().subtract(20,'years').toISOString();
  maxDate = moment().add(20,'years').toISOString();

	constructor(
    private alertCtrl : AlertController,
    public navCtrl: NavController, 
    public navParams: NavParams, 
    httpClient : HttpClient,
    customToast : CustomToast,
    modalCtrl : ModalController, 
    events : Events) {

		this.modalCtrl = modalCtrl;
    this.httpClient = httpClient;
    this.customToast = customToast;
    this.events = events;
  }

  ionViewDidLoad() {
    this.navBar.backButtonClick = (e:UIEvent)=>{
     let alert = this.alertCtrl.create({
      title : '¿Seguro que deseas salir?',
      message : 'Los datos no guardados se perderán',
      buttons : [
        {
          text : 'Salir',
          handler : () =>{
            this.navCtrl.pop();
          }
        },
        {
          text : 'Cancelar',
          role : 'cancel'
        }
      ]
     });

     alert.present();
    }
  }
  
  httpPostPublication(){
    this.httpClient.post('/publications',this.publication,(error,data)=>{
      if(!error){
        this.customToast.showMessage('Publicación creada correctamente',2000);
        this.navCtrl.pop();
        this.events.publish('addPublication:done');
      }
    });
  }

  onClickSave(){
    this.httpPostPublication();
  }

}



// WEBPACK FOOTER //
// ./src/pages/dashboard/publications/addPublication/addPublication.ts